module.exports = __webpack_public_path__ + "img/hatate himekaidou_sc1.3885d233.png";